export default "__VITE_ASSET__CuNJLejf__"